import React, { useState } from 'react';
import Spacer from '../../../components/presentational/Spacer';
import styled, { cx, StylesProps } from '../../../lib/styles';
import BlockWrapper from '../BlockWrapper';
import { ButtonPosition, DefaultBlockFields } from '../GroupBlock';
import theme, { Brand } from '../../../lib/theme';
import cardGridBlockStyles from './CardGridBlock_styles';
import { CallToActionButton } from '../CallToActionButton';
import clsx from 'clsx';
import BlockTitle from '../BlockTitle';
import _ from 'lodash';

const { layouts, scale, media, colors } = theme;

export interface CardGridBlockProps {
  type: 'acf_cardgrid_block';
  brand: string;
  classes: string;
  background_colour: string;
  desktop_spacing: string;
  mobile_spacing: string;
  block: CardGridBlockFields;
}

interface Card {
  desktop_image: string;
  mobile_image: string;
  top_title: string;
  bottom_title: string;
  url: string;
}

export interface CardGridBlockFields extends DefaultBlockFields {
  columns_per_row: number;
  half_size_cards: boolean;
  apply_border_drop_shadow: boolean;
  cards: Card[];
}

const CardGridBlock = ({
  type,
  classes,
  brand,
  background_colour,
  desktop_spacing,
  mobile_spacing,
  block: { title, subtitle, cards, cta_button },
  styles,
}: CardGridBlockProps & StylesProps<typeof cardGridBlockStyles>) => {
  // console.log('CardGridBlock', {
  //   background_colour,
  //   desktop_spacing,
  //   mobile_spacing,
  //   half_size_cards,
  //   cta_button,
  //   ...cards,
  // });

  return (
    <BlockWrapper
      {...{
        type,
        classes,
        brand,
        background_colour,
        desktop_spacing,
        mobile_spacing,
      }}
    >
      <Spacer
        space={['m', 'l']}
        className={cx(`cardGrids-container container`, styles.container)}
      >
        {(cta_button.label || cta_button.icon) &&
          (cta_button.button_position == ButtonPosition.Above ||
            cta_button.button_position == ButtonPosition.AboveAndBelow) && (
            <CallToActionButton
              {..._.merge(cta_button, { cta_classes: 'mb-2' })}
            />
          )}

        <BlockTitle {...{ title, subtitle, brand }} />

        {cards.length > 0 && (
          <div
            className={`cardGrid-cards-container ${styles.cardGridContainer}`}
          >
            {cards &&
              cards.map((card, index) => {
                // console.log('card', {...card});
                return (
                  <div
                    key={index}
                    className={`card cardgrid-card ${styles.cardGridCard}`}
                    onClick={() => {
                      window.location.href = card.url;
                    }}
                    style={{
                      cursor: card.url ? 'pointer' : 'default',
                    }}
                  >
                    {card.top_title && (
                      <div
                        className={cx(
                          'd-flex cardgrid-content',
                          styles.cardGridContent,
                          styles.cardGridContentTop
                        )}
                      >
                        <h6>{card.top_title}</h6>
                      </div>
                    )}
                    <img
                      loading="lazy"
                      src={`${card.desktop_image}?w=500`}
                      className={clsx(`cardGridImage`, styles.cardGridImage, {
                        hasMobileImage: card.mobile_image,
                      })}
                      alt={card.top_title ?? card.bottom_title}
                    />
                    {card.mobile_image && (
                      <img
                        loading="lazy"
                        src={`${
                          card.mobile_image
                            ? card.mobile_image
                            : card.desktop_image
                        }?w=500`}
                        className={cx(
                          `cardGridMobileImage`,
                          styles.cardGridMobileImage
                        )}
                        alt={card.top_title ?? card.bottom_title}
                      />
                    )}
                    {card.bottom_title && (
                      <div
                        className={cx(
                          'd-flex cardgrid-content',
                          styles.cardGridContent,
                          styles.cardGridContentBottom
                        )}
                      >
                        <h6
                          style={{
                            color: `${colors.white} !important`,
                            margin: '0 !important',
                          }}
                        >
                          {card.bottom_title}
                        </h6>
                      </div>
                    )}
                  </div>
                );
              })}
          </div>
        )}
        {(cta_button.label || cta_button.icon) &&
          (cta_button.button_position == ButtonPosition.Below ||
            cta_button.button_position == ButtonPosition.AboveAndBelow) && (
            <CallToActionButton
              {..._.merge(cta_button, { cta_classes: 'mt-4 mb-2' })}
            />
          )}
      </Spacer>
    </BlockWrapper>
  );
};

export default styled(cardGridBlockStyles)(CardGridBlock);
